import { useIsVisible } from '@application/use_is_visible';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';

interface Props {
	shouldBeObserved: boolean;
	onVisible: () => void;
}

const elements = {
	bottomSection: styled.span`
		position: absolute;
		bottom: 0;
		width: 100%;
		left: 0px;
		height: 30px;
	`,
};

export function ReadUntilContainer({ shouldBeObserved, onVisible }: Props): JSX.Element {
	const ref = useRef<HTMLDivElement>(null);
	const isVisible = useIsVisible(ref);

	useEffect(() => {
		if (shouldBeObserved && isVisible) {
			onVisible();
		}
	}, [isVisible, onVisible, shouldBeObserved]);

	return <elements.bottomSection ref={ref} />;
}
